<template>
  <div>
    <b-table
      small
      striped
      :items="bonusInfoItems"
      :fields="bonusInfoFields"
    ></b-table>
  </div>
</template>

<script>
export default {
  name: 'BonusInfoTable',
  props: {
    // Array of bonus info items: [{ id: '<inventoryId>', name: '<inventoryName>', bonusInfo: {<bonusInfoObject>} }]
    bonusInfoList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    bonusInfoFields() {
      return [
        {
          label: this.$t('general.itemName'),
          key: 'name',
        },
        {
          label: this.$t('bonusInventory.remainingPurchaseForFreeItem'),
          key: 'purchaseQtyToGo',
          class: 'text-center',
        },
        {
          label: this.$t('bonusInventory.remainingFreeItems'),
          key: 'unredeemedBonusQty',
          class: 'text-center',
        },
      ];
    },
    bonusInfoItems() {
      return this.bonusInfoList.map(i => {
        return {
          name: i.name,
          purchaseQtyToGo: i.bonusInfo.purchaseQtyToGo,
          unredeemedBonusQty: i.bonusInfo.unredeemedBonusQty,
        };
      });
    },
  },
};
</script>
